import { Color } from './color';
/**
 * A hollow path.
 */
export var Hollow = function Hollow(options, context) {
  return Color(Object.assign({
    fill: 'none',
    colorAttribute: 'stroke'
  }, options), context);
};
Hollow.props = {
  defaultMarker: 'hvh',
  defaultEnterAnimation: 'fadeIn',
  defaultUpdateAnimation: 'morphing',
  defaultExitAnimation: 'fadeOut'
};